import { appEventModule } from "app/event"
import { getStore } from "app/store/store"
import { APP_CONTAINER_ID } from "ui/model"
import { uiActionCreator } from "ui/store/actions"

export function getOrCreateAppContainer(): HTMLDivElement {
  let appContainer: HTMLDivElement = document.getElementById(APP_CONTAINER_ID) as HTMLDivElement
  if (!appContainer) {
    appContainer = document.createElement("div")
    appContainer.id = APP_CONTAINER_ID
    document.body.append(appContainer)
    let timeout: any
    appEventModule.on.windowResize("app-container-resize", () => {
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        getStore().dispatch(
          uiActionCreator.setContainerSize({
            width: document.body.offsetWidth,
            height: document.body.offsetHeight
          })
        )
      }, 250)
    })
  }
  return appContainer
}
